import React, { useState, useEffect } from 'react';
import InputGroup from './ui/InputGroup';
import ResultCard from './ui/ResultCard';
import ToggleGroup from './ui/ToggleGroup';

const YieldCalculator = () => {
  const [amount, setAmount] = useState(5);
  const [unit, setUnit] = useState('lbs');
  const [potSize, setPotSize] = useState(96);
  const [strength, setStrength] = useState('standard');
  const [coffeeState, setCoffeeState] = useState('ground');

  const [totalPots, setTotalPots] = useState(0);
  const [totalCups, setTotalCups] = useState(0);

  useEffect(() => {
    // Total coffee available in ounces
    const totalCoffeeOz = unit === 'lbs' ? amount * 16 : amount;
    
    // Coffee needed per pot based on user's 96oz baseline
    const ozPerFlOz = strength === 'standard' ? (1.5 / 96) : (2.0 / 96);
    const coffeePerPotOz = potSize * ozPerFlOz;
    
    if (coffeePerPotOz > 0) {
      const pots = totalCoffeeOz / coffeePerPotOz;
      setTotalPots(pots.toFixed(1));
      
      // Calculate servings based on 8oz "cups" (96oz / 12 cups)
      const totalVolumeFlOz = pots * potSize;
      setTotalCups((totalVolumeFlOz / 8).toFixed(0));
    }
  }, [amount, unit, potSize, strength, coffeeState]);

  return (
    <div className="space-y-8 animate-fade-in">
      <div>
        <h2 className="text-2xl font-bold text-white mb-2">Inventory Yield</h2>
        <p className="text-slate-400">Pounds to Pots conversion based on your custom strength settings.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="space-y-6">
          <div className="grid grid-cols-2 gap-3">
            <InputGroup
              label="Inventory Amount"
              id="amount"
              value={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
              min="0.1"
            />
            <ToggleGroup
              label="Weight Unit"
              activeValue={unit}
              onChange={setUnit}
              options={[
                { label: 'Pounds (lbs)', value: 'lbs' },
                { label: 'Ounces (oz)', value: 'oz' },
              ]}
            />
          </div>
          <InputGroup
            label="Pot Size"
            id="potSize"
            value={potSize}
            onChange={(e) => setPotSize(Number(e.target.value))}
            unit="fl oz"
            min="1"
          />
        </div>

        <div className="space-y-6">
          <ToggleGroup
            label="Brew Strength"
            activeValue={strength}
            onChange={setStrength}
            options={[
              { label: 'Standard', value: 'standard' },
              { label: 'Bold', value: 'bold' },
            ]}
          />
          <ToggleGroup
            label="Coffee State"
            activeValue={coffeeState}
            onChange={setCoffeeState}
            options={[
              { label: 'Whole Bean', value: 'whole' },
              { label: 'Ground', value: 'ground' },
            ]}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
        <ResultCard title="Total Pots Yield" value={totalPots} unit="pots" highlight={true} />
        <ResultCard title="Estimated 8oz Cups" value={totalCups} unit="cups" />
      </div>
    </div>
  );
};

export default YieldCalculator;